module.exports = __webpack_public_path__ + "img/18.72ce2673.jpg";